import Chip from '@carvana/ds-chip';
import useGetConsumerHref from '~/hooks/common/selectors/useGetConsumerHref';
import { nativeSrpPayload } from '~/native/common/utils';
import { SuggestedSearch } from './useGetSuggestedSearches';

type OwnProps = {
  links: SuggestedSearch[];
};

export default function SuggestedLinks({ links }: OwnProps) {
  const getHref = useGetConsumerHref();

  return (
    <div
      className="flex h-full flex-wrap content-start items-start justify-start gap-md overflow-hidden"
      data-testid="suggested-search-links"
    >
      {links.map(({ Icon, title, link }) => (
        <a
          data-analytics-id="Home feed card"
          data-analytics-attributes={JSON.stringify({
            description: 'Search Card',
            type: 'suggested',
            item: 'search'
          })}
          data-testid="suggested-search-link"
          data-native-payload={nativeSrpPayload}
          key={title}
          href={getHref(link)}
        >
          <Chip icon={Icon ? Icon : undefined} iconPosition="left" size="large">
            {title}
          </Chip>
        </a>
      ))}
    </div>
  );
}
